module.exports = __webpack_public_path__ + "img/comment.768da8f3.svg";